(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-left-text-right"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    new Swiper('.carousel-wrapper', {
      loop: true,
      slidesPerView: 1 /* ✅ Show only one slide at a time */,
      spaceBetween: 150 /* ✅ No gap between slides */,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
